export default __webpack_public_path__ + "static/media/audio-teaser-stop.87bd3b36.svg";